import gCard from "@/components/g-card/g-card";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import gForm from "@/components/g-form/g-form.vue";
import gButton from "@/components/g-button/g-button.vue"
import PDFPedidoFinal from "./PDF/PDFPedidoFinal.vue";
import PedidoEmAndamentoPDF from "@/pages/Pedidos/PedidoEmAndamento/components/DetalhesPedidoEmAndamento/PDF/PedidoEmAndamentoPDF.vue";

const name = 'PedidoFinal'
export default {
  name,

  components: {
    'g-card': gCard,
    'g-pdf': gPdf,
    'g-form': gForm,
    'g-button': gButton,
    PDFPedidoFinal,
    PedidoEmAndamentoPDF
   },

  props: { },

  mounted () {
    var pediId =  this.$route.params.id
    this.PedidoId = pediId
    this.PopulaResumoFinal()
    this.PopulaResumoFinalFrete()
    
  },

  updated () { },

  data () {
    return {
      PedidoArray:[],
      PedidoFreteArray:[],
      renderiza: false,
      quantidadeParcelaArray: [],
      executarvisualizacao: 0,
      PedidoId: null,
      PopupTemSequenciaAinda: false
    }
  },

  methods: {
    gerarPdf() {
      this.executarvisualizacao++
    },
    
    pdfFinal(){
      this.renderiza = true
      this.executarvisualizacao++
      this.PedidoId = this.$route.params.id
    },
    
    GetQuantidadeParcela(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetQuantidadeParcela/${this.PedidoId}`,
      })
      .then((response) =>{
        this.quantidadeParcelaArray = response.data.data;
        // this.VerificaSeEhUltimaSequencia()
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },
    PopulaResumoFinal(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetResumoFinalPedido/${this.PedidoId}`,
      })
      .then((response) =>{
        this.GetQuantidadeParcela();
        this.PedidoArray = response.data.data;
        if(this.PedidoArray.orcamentoSequenciaId != null){
          this.VerificaSeEhUltimaSequencia()
        }
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },


    VerificaSeEhUltimaSequencia(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/VerificaSeEhUltimaSequencia/${this.PedidoId}`,
      })
      .then((response) =>{
        if(response.data.data == false){
          this.PopupTemSequenciaAinda = true
        }

      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },

    novoPedido () {
      this.$router.push('/gerar-novo-pedido-inicio')
    },

    PopulaResumoFinalFrete(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetResumoFinalPedidoFrete/${this.PedidoId}`,
      })
      .then((response) =>{
        this.PedidoFreteArray = response.data.data;
        // this.VerificaSeEhUltimaSequencia()
      })
      .catch(() => {
      });
    },
    consultarpedidos(){
      this.$router.push('/gerar-novo-pedido-inicio')
    }
  },

  computed: { },

};